import { IDFormControl } from './../../d-form/d-form.helpers';
import { Component, OnInit, Output, EventEmitter, Input, OnChanges, ElementRef, ViewChild } from '@angular/core';
import { getLinkTrainerForm } from './link-trainer.component.element';
import { TrainerService, TRAINER_STATUS } from 'projects/services/src/app/API/trainer.service';
import { UserService } from 'projects/services/src/app/API/user.service';
import { LoadingService } from 'projects/services/src/app/loading.service';
import { TrainingCentersService } from 'projects/services/src/app/API/training-centers.service';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { STATE } from 'projects/training-partner/src/app/training-partner/constants';
import { FormBuilder, Validators } from '@angular/forms';
import { CurrentUserService } from 'projects/services/src/app/current-user.service';
import { TrainingPartnerService } from 'projects/services/src/app/API/training-partner.service';

import * as moment from 'moment';

declare const toastr: any;
declare const swal: any;

export const FORM_STATE = STATE;
const MODAL_ID = {
	TRAINER: 'linkNewTrainer'
};
@Component({
	selector: 'app-link-trainer',
	templateUrl: './link-trainer.component.html',
	styleUrls: ['./link-trainer.component.css']
})
export class LinkTrainerComponent implements OnInit, OnChanges {
	linkTrainerForm: any;
	trainer: any = {};
	linkTrainerFormControl: IDFormControl;
	trainingCentres: any = [];
	pageNo = 1;
	itmesPerPage = 10;
	loggedInUser: any;
	trainingCentre: any;
	trainingCentreName: any;
	trainingCentreList: any;
	startDate: any;
	endDate: any;
	trainerId: any;

	allowedFormats = ['pdf', 'docx', 'jpeg', 'jpg', 'png'];
	localFileName = {
		supportingDocument: '',
	};
	submitText: any;
	isDisabled = false;
	isModalOpen: boolean;
	constructor(
		private trainerService: TrainerService,
		private userService: UserService,
		private loadingService: LoadingService,
		private fb: FormBuilder,
		private trainingPartnerService: TrainingPartnerService,
		private currentUserService: CurrentUserService,
	) { }

	STATE = STATE;
	@Output() generateOtp = new EventEmitter();
	@Input() selectedSchemeId;
	@Output() controlChange = new EventEmitter();
	@Output() editTrainer = new EventEmitter();
	@Input() state = STATE.FILLING;
	@Input() defaultValues: any = {};
	visible = true;

	ngOnChanges(changes) {
		this.closeModel();
		if (changes && changes.state) {
			this.visible = false;
			setTimeout(() => this.ngOnInit());
		}
	}
	ngOnInit() {
		this.getCurrentUser();
		this.createLinkTrainerForm();

		switch (this.state) {
			case STATE.FILLING: {
				this.isDisabled = false;
				this.isModalOpen = false;
				this.submitText = 'Generate OTP';
				break;
			}
			case STATE.EDITING: {
				this.isDisabled = true;
				this.submitText = 'Save'
				this.isModalOpen = true;
				this.onViewTrainerAssociation();
				break;
			}
		}
		// const param = 'userName,trainingCentreName'
		// this.trainingCentreService.getTrainingCentreOfScheme(this.selectedSchemeId, undefined, {
		// 	pageNo: 1,
		// 	limit: 10,
		// 	withoutPagination:  true,
		// 	backEndQuery: {}
		// }, param)
		// 	.subscribe(({data}) => {
		// 		data = data || [];
		// 		const tcs = data.map(tc => ({
		// 			name: `${tc.trainingCentreName} (${tc.userName})`,
		// 			value: {
		// 				userName: tc.userName,
		// 				name: tc.trainingCentreName
		// 			}
		// 			}));
		// 		Helpers.copyArray(this.trainingCentres, tcs);
		// 		// console.log(data);
		// 	});
		// let submitText;
		// const hide: any = {};
		// const disableFields: any = {};
		// const cancelText = 'Cancel';
		// switch (this.state) {
		// 	case STATE.FILLING: {
		// 		submitText = 'Generate OTP';
		// 		break;
		// 	}
		// 	case STATE.EDITING: {
		// 		submitText = 'Save';
		// 		hide.nameOfTheTrainer = true;
		// 		hide.trainerId = true;
		// 		break;
		// 	}
		// 	case STATE.VIEWING: {
		// 		disableFields.all = true;
		// 		this.defaultValues.trainerId = this.defaultValues.trainerId || this.defaultValues.idOfTrainer;
		// 		this.defaultValues.tc = Helpers.getValueFromObject(this.defaultValues, 'tc.userName');
		// 		submitText = 'Ok';
		// 		break;
		// 	}
		// }
		// const formInputs = Object.assign({}, this.defaultValues, {
		// 	trainingCentres: this.trainingCentres,
		// 	submitLable: submitText,
		// 	cancelLable: cancelText,
		// });
		// this.linkTrainerForm = getLinkTrainerForm(formInputs, {
		// 	sdmsIdChange: this.onSdmsIdChange.bind(this),
		// 	sdmsIdBlur: this.onSdmsIdBlur.bind(this),
		// 	tcIdChange: this.tcIdChange.bind(this),
		// 	tcIdBlur: this.tcIdBlur.bind(this)
		// }, hide, disableFields);

		// this.visible = true;

	}

	// onGenerateOtp(data) {
	// 	const trainerId = data.trainerId;
	// 	this.loadingService.blockModal();
	// 	const linkTrainerData = this.linkTrainerFormControl.value();
	// 	this.linkTrainerFormControl.reset();
	// 	linkTrainerData.tcName = linkTrainerData.associatedTrainingCentre.name;
	// 	linkTrainerData.tcUserName = linkTrainerData.associatedTrainingCentre.userName;
	// 	this.userService.generateOTP(trainerId, UserService.USER_STEP.LINK_TRAINER).subscribe(
	// 		() => {
	// 			this.loadingService.unblockuI();
	// 			this.generateOtp.emit(linkTrainerData);
	// 		},
	// 		err => {
	// 			console.log(err);
	// 			this.loadingService.unblockuI();
	// 		}
	// 	);
	// }


	// emitControl() {
	// 	this.controlChange.emit(this.linkTrainerFormControl);
	// }

	// onSdmsIdChange() {
	// 	this.linkTrainerFormControl.patchValues({
	// 		nameOfTheTrainer: null
	// 	});
	// }

	// onSdmsIdBlur(data) {
	// 	if (!data) {
	// 		return;
	// 	}
	// 	this.trainerService.getTrainerInfo(data, TRAINER_STATUS.REGISTRATION_COMPLETED).subscribe(trainerInfo => {
	// 		if (!trainerInfo) {
	// 			this.onSdmsIdChange();
	// 			return;
	// 		}
	// 		this.trainer = trainerInfo;
	// 		const name = trainerInfo.name;
	// 		this.linkTrainerFormControl.patchValues({
	// 			nameOfTheTrainer: name
	// 		});
	// 	});
	// }

	// tcIdChange() {
	// 	this.linkTrainerFormControl.patchValues({
	// 		associatedTrainingCentre: null
	// 	});
	// }

	getTrainingCentreList(event) {
		const tcName = event.target.value
		this.trainingCentreList = [];
		if (event.target.value.length < 5 || event.keyCode === 8) {
			return;
		} else {
			console.log(this.linkTrainerForm, event)
			const data = {
				'selectedSchemeId': this.selectedSchemeId,
				'userName': this.loggedInUser.userName,
				'tcName': tcName,
				'pageNo': this.pageNo,
				'itemsPerPage': this.itmesPerPage
			}
			let str = tcName.split(/[()]/)
			if (str.length >= 2) {
				//check if api is already called and block next call when selected from list
					return;
			}
			console.log(data);
			this.userService.getTrainingCentreList(data).subscribe(res => {
				this.trainingCentreList = res.data;
				console.log(this.trainingCentreList)
			})
		}


		// this.userService.getTrainingCentreList(data).subscribe(({ data }) => {
		// 	// data = data || [];
		// 	// const tcs = data.map(tc => ({
		// 	// 	name: `${tc.trainingCentreName} (${tc.userName})`,
		// 	// 	value: {
		// 	// 		userName: tc.userName,
		// 	// 		name: tc.trainingCentreName
		// 	// 	}
		// 	// }));
		// 	// Helpers.copyArray(this.trainingCentres, tcs);
		// });
	}

	getCurrentUser() {
		this.currentUserService.getAdditionalInfomartion().subscribe(res => {
			console.log(res);
			this.loggedInUser = res
		})
	}

	createLinkTrainerForm() {
		this.linkTrainerForm = this.fb.group({
			trainerId: ['', Validators.required],
			trainerName: ['', Validators.required],
			associatedTrainingCentre: ['', Validators.required],
			validity: this.fb.group({
				fromDate: ['', Validators.required],
				toDate: ['', Validators.required],
			}),
			supportingDocument: ['', Validators.required]
		})
	}

	takeAction() {
		if (this.state === STATE.FILLING) {
			this.onGenerateOtp();
		}
		if (this.state === STATE.EDITING) {
			this.updateTrainer();
		}
	}

	onViewTrainerAssociation() {
		console.log(this.defaultValues);
		this.linkTrainerForm.get('trainerId').patchValue(this.defaultValues.idOfTrainer);
		this.linkTrainerForm.get('trainerName').patchValue(this.defaultValues.nameOfTheTrainer);
		this.linkTrainerForm.get('associatedTrainingCentre').patchValue(this.defaultValues.tcUserName);
		this.linkTrainerForm.get('associatedTrainingCentre').disable();
		this.linkTrainerForm.get('supportingDocument').patchValue(this.defaultValues.supportingDocuments);
	}

	updateTrainer() {
		let isFileUploade = this.linkTrainerForm.getRawValue() && this.linkTrainerForm.getRawValue().supportingDocument && this.linkTrainerForm.getRawValue().supportingDocument.lastModified || '';
		if (isFileUploade !== '') {
			toastr.error('Please upload file to continue...');
			return;
		}
		this.linkTrainerForm.get('validity').get('fromDate').setValue(this.startDate);
		this.linkTrainerForm.get('validity').get('toDate').setValue(this.endDate);
		const linkedTrainerData = this.generateUpdatedTrainewrData()
		this.trainingPartnerService.updateAssociatedTrainerDetails(linkedTrainerData).subscribe(res => {
			if (res) {
				Helpers.closeModal(MODAL_ID.TRAINER);
				swal('Trainer Updated Successfully', `Trainer ${linkedTrainerData.trainerId} updated successfully`, 'success');
				this.editTrainer.emit(Object.assign({}, this.defaultValues, linkedTrainerData));
			}
		})
	}

	closeFix(event, datePicker) {
		if (event.target.offsetParent == null) {
			datePicker.close();
		} else if (event.target.offsetParent.nodeName !== 'NGB-DATEPICKER') {
			datePicker.close();
		}
	}


	generateUpdatedTrainewrData() {
		const updatedTrainerData = {
			'supportingDocuments': this.linkTrainerForm.get('supportingDocument').value,
			'tcUserName': this.defaultValues.tcUserName,
			'tpUserName': this.defaultValues.tpUserName,
			'trainerId': this.linkTrainerForm.get('trainerId').value,
			'schemeId': this.selectedSchemeId,
			'validity': {
				'fromDate': this.linkTrainerForm.get('validity').get('fromDate').value ? this.linkTrainerForm.get('validity').get('fromDate').value : this.defaultValues.validity.fromDate,
				'toDate': this.linkTrainerForm.get('validity').get('toDate').value ? this.linkTrainerForm.get('validity').get('toDate').value : this.defaultValues.validity.toDate,
			},
		 	'oldValidity': {
				'fromDate': this.defaultValues.validity.fromDate,
				'toDate': this.defaultValues.validity.toDate
			}
		}
		return updatedTrainerData;
	}

	getTrainerName() {
		this.trainerId = this.linkTrainerForm.get('trainerId').value;
		this.trainerService.getTrainerInfo(this.trainerId, TRAINER_STATUS.REGISTRATION_COMPLETED).subscribe(trainerInfo => {
			if (!trainerInfo) {
				return;
			}
			this.trainer = trainerInfo;
			const name = trainerInfo.name;
			this.linkTrainerForm.get('trainerName').patchValue(name);
		});
	}

	selectedStartDate(event) {
		if (event) {
			const date = this.stringdates(event);
			this.startDate = date;
		}

	}

	selectedEndDate(event) {
		if (event) {
			const date = this.stringdates(event);
			this.endDate = date;
		}
	}

	stringdates(dateObj) {
		const strDate = `${dateObj.day}/${dateObj.month}/${dateObj.year}`;
		const date = moment(strDate, 'DD/MM/YYYY');
		return date.format('YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	}

	onSubmit(data) {
		console.log(data)
		if (this.linkTrainerFormControl.isValid()) {
			data = this.linkTrainerFormControl.value();
			data.associatedTrainingCentre = this.trainingCentreName;
			switch (this.state) {
				case STATE.FILLING: {
					this.onGenerateOtp(data);
					break;
				}
				case STATE.EDITING: {
					data.tc = data.associatedTrainingCentre;
					data.tcName = data.associatedTrainingCentre.name;
					data.tcUserName = data.associatedTrainingCentre.userName;
					this.editTrainer.emit(Object.assign({}, this.defaultValues, data));
					break;
				}
				case STATE.VIEWING: {
					break;
				}
			}
		}
	}


	generateLinkTrainerData(data) {
		let tcname = data[0].trim();
		const linkTrainerData = {
			'associatedTrainingCentre': {
				'name': tcname,
				'userName': data[1]
			},
			'nameOfTheTrainer': this.linkTrainerForm.get('trainerName').value,
			'supportingDocuments': this.linkTrainerForm.get('supportingDocument').value,
			'tcId': data[1],
			'tcName': tcname,
			'tcUserName': data[1],
			'trainerId': this.linkTrainerForm.get('trainerId').value,
			'validity': {
				'fromDate': this.linkTrainerForm.get('validity').get('fromDate').value,
				'toDate': this.linkTrainerForm.get('validity').get('toDate').value,
			},
			'originationCategory': this.trainer.originationCategory
		}
		return linkTrainerData;
	}

	onGenerateOtp(data?) {
		let isFileUploade = this.linkTrainerForm.getRawValue() && this.linkTrainerForm.getRawValue().supportingDocument && this.linkTrainerForm.getRawValue().supportingDocument.lastModified || '';
		if (isFileUploade !== '') {
			toastr.error('Please upload file to continue...');
			return;
		}
		if (this.linkTrainerForm.status === "INVALID") {
			toastr.error('All fields are required');
			return;
		}

		this.loadingService.blockModal();
		const tcId = this.linkTrainerForm.get('associatedTrainingCentre').value;
		const trainingCentreId = tcId.split(/[()]/);
		this.linkTrainerForm.get('validity').get('fromDate').setValue(this.startDate);
		this.linkTrainerForm.get('validity').get('toDate').setValue(this.endDate);
		const linkTrainerData = this.generateLinkTrainerData(trainingCentreId);
		console.log(linkTrainerData);
		this.userService.generateOTP(this.trainerId, UserService.USER_STEP.LINK_TRAINER).subscribe(
			() => {
				this.loadingService.unblockuI();
				this.generateOtp.emit(linkTrainerData);
			},
			err => {
				console.log(err);
				this.loadingService.unblockuI();
			});
		}

	closeModel() {
		this.linkTrainerForm.get('trainerId').setValue('');
		this.linkTrainerForm.get('trainerName').setValue('');
		this.linkTrainerForm.get('associatedTrainingCentre').setValue('');
		this.linkTrainerForm.get('supportingDocument').setValue('');
		this.linkTrainerForm.get('validity').get('fromDate').setValue(null);
		this.linkTrainerForm.get('validity').get('toDate').setValue(null);
	}


}
